import { labelMap } from './constants';

export default function TextValue({ value, typeSelected }) {
    const isArrayType = Array.isArray(value);
    if (isArrayType) {
        return labelMap[typeSelected] || '';
    }
    return value || '';
}
